import apiSlice from "state/api/apiSlice";
import { setCredentials } from "state/auth/authSlice";
import { logOut } from "./authSlice";

export const authApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    signup: builder.mutation({
      query: (user) => ({
        url: "/auth/signup",
        method: "POST",
        body: {
          ...user,
        },
      }),
    }),
    changePassword: builder.mutation({
      query: ({ password, token }) => ({
        url: `/auth/password_reset/${token}`,
        method: "POST",
        body: {
          password,
        },
      }),
    }),
    resetPasswordRequest: builder.mutation({
      query: (email) => ({
        url: "/auth/password_reset_request",
        method: "POST",
        body: {
          ...email,
        },
      }),
    }),
    login: builder.mutation({
      query: (credentials) => ({
        url: "/auth/login",
        method: "POST",
        headers: {
          "content-type": "application/x-www-form-urlencoded",
        },
        body: `grant_type=password&username=${credentials.email}&password=${credentials.password}&scope=&client_id=&client_secret=`,
      }),
    }),
    refresh: builder.mutation({
      query: () => {
        const refreshToken = localStorage.getItem("refreshToken");
        if (!refreshToken) {
          throw new Error("No refresh token available");
        }
        return {
          url: "/auth/refresh",
          method: "POST",
          body: {
            refresh_token: refreshToken,
          },
        };
      },
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(setCredentials({ ...data }));
        } catch (error) {
          // eslint-disable-next-line
          dispatch(logOut());
        }
      },
    }),
    logout: builder.mutation({
      query: () => {
        const refreshToken = localStorage.getItem("refreshToken");
        return {
          url: "/auth/logout",
          method: "POST",
          body: {
            refresh_token: refreshToken || "",
          },
        };
      },
    }),
    getMyPermissions: builder.query({
      query: () => ({
        url: "/permissions/me",
        method: "GET",
        validateStatus: (response, result) => response.status === 200 && !result?.isError,
      }),
      providesTags: ["MyPermissions"],
    }),
  }),
});

export const {
  useSignupMutation,
  useLoginMutation,
  useRefreshMutation,
  useLogoutMutation,
  useResetPasswordRequestMutation,
  useChangePasswordMutation,
  useGetMyPermissionsQuery,
} = authApiSlice;
